import store from '@/vuex/store'
import { liveStats } from './liveStats'
import kvSyncSubscriber from './kvSync'
import mqttClient from './mqtt.client'

function init() {
  liveStats.connect()
  kvSyncSubscriber.init()

  // Counting is published non-retained, so updates sent while the connection was down never arrive.
  mqttClient.on('connect', () => {
    store.dispatch('counting/reseed').catch(() => {})
  })

  // Tighten the MQTT keepalive while presenting so a broker drop is detected in
  // seconds rather than up to ~90s (feeds the AHA-40903 connection banner).
  // Gated on canUseNetworkIndicatorV2: the tighter keepalive only exists to feed
  // that banner, so when the flag is off we never touch setPresenting at all and
  // the default keepalive is left untouched. isPresenting flips on entering/
  // leaving present mode mid-session, and the flag may resolve after init() runs,
  // so we watch the combined (flag && isPresenting) value — but only ever call
  // setPresenting from inside the flag guard. Apply the current value immediately
  // in case we booted straight into a present link with the flag already on.
  const applyKeepalive = (getters) => {
    if (!getters['featureToggles/canUseNetworkIndicatorV2']) {
      return
    }
    mqttClient.setPresenting(getters.isPresenting)
  }
  applyKeepalive(store.getters)
  store.watch(
    (_state, getters) => getters['featureToggles/canUseNetworkIndicatorV2'] && getters.isPresenting,
    () => applyKeepalive(store.getters),
  )
}

export default { init }
